import { useState } from 'react'
import styles from './LOSModal.module.css'
import axios from 'axios'
import { url } from '../../../../../../App'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router'
import Cookies from 'js-cookie';

const LOSModal = ({ closeModal, loanId }) => {
    const Navigate = useNavigate()
    const [losID, setLosID] = useState('')
    const handleSubmit = async () => {
        const request = {
            token: Cookies.get('Token'),
            email: Cookies.get('Email'),
            borrower_uniqueno: localStorage.getItem('uniqueID'),
            loan_id: loanId,
            nbfc_los_id: losID,
        }
        const { data } = await axios.post(url + '/loan/addlosid', request)
        if (!data.auth) {
            toast.error(data.message)
            if (data.logout) {
                setTimeout(() => {
                    Navigate('/')
                }, 1500)
            }
            return
        }
        toast.success(data.message)
        window.location.reload()
    }
    return (
        <div className={styles.losModal}>
            <div
                className={styles.losModaOverlay}
                onClick={(e) => e.target === e.currentTarget && closeModal()}
            >
                <div className={styles.losModalContent}>
                    <div className={styles.losContent}>
                        <label htmlFor="">NBFC LOS ID</label>
                        <input
                            type="text"
                            className={styles.losInput}
                            onChange={(e) => setLosID(e.target.value)}
                        />
                        <button onClick={handleSubmit}>SUBMIT</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LOSModal
